/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
import { Auth } from 'aws-amplify';
export default function SignOut() {
  window.appSyncClient = null;
  Auth.signOut()
    .catch(err => console.log('error signing out: ', err));
}
